import * as React from "react";

import { AccountActions } from "../AccountActions";
import { HelpLinks } from "../HelpLinks";
import { QuickActions } from "../QuickActions";
import { UserHeader } from "../UserHeader";
import { WorkspaceInviteItem } from "../WorkspaceInviteItem";
import { WorkspacesList } from "../WorkspacesList";

import { DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown";
import { Organization } from "@/types/organizations";
import { WorkspaceInvite } from "@/types/workspace-invite";
import { Workspace } from "@/types/workspaces";

interface UserDropdownContentProps {
  email: string;
  userRole: string;
  workspaceInvites: WorkspaceInvite[];
  organizations: Organization[];
  workspaces: Workspace[];
  activeOrganizationId?: number;
  activeWorkspaceId?: number;
  defaultOrganizationId?: number;
  canInvite: boolean;
  onWorkspaceSelect: (workspaceId: number) => void;
  onOrganizationSelect: (organizationId: number) => void;
  onInviteClick: () => void;
  onManageOrganizations: () => void;
  onManageWorkspaces: () => void;
  onReferFriend: () => void;
  onLogout: () => void;
  onCloseMenu: () => void;
  getDefaultWorkspaceId: (organizationId: number) => number | undefined;
}

export const UserDropdownContent: React.FC<UserDropdownContentProps> = ({
  email,
  userRole,
  workspaceInvites,
  organizations,
  workspaces,
  activeOrganizationId,
  activeWorkspaceId,
  defaultOrganizationId,
  canInvite,
  onWorkspaceSelect,
  onOrganizationSelect,
  onInviteClick,
  onManageOrganizations,
  onManageWorkspaces,
  onReferFriend,
  onLogout,
  onCloseMenu,
  getDefaultWorkspaceId,
}) => (
  <>
    <UserHeader email={email} userRole={userRole} />

    <div className="max-h-[60vh] overflow-y-auto py-1">
      {/* Workspace Invites */}
      {workspaceInvites.length > 0 && (
        <>
          <DropdownMenuLabel className="px-3 pb-1 pt-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
            Invitations
          </DropdownMenuLabel>
          {workspaceInvites.map(invite => (
            <WorkspaceInviteItem
              key={invite.id}
              invite={invite}
              onAccept={onCloseMenu}
              onReject={() => undefined}
            />
          ))}
          <DropdownMenuSeparator className="my-1" />
        </>
      )}

      {/* Workspaces Section */}
      <WorkspacesList
        organizations={organizations}
        workspaces={workspaces}
        activeOrganizationId={activeOrganizationId}
        activeWorkspaceId={activeWorkspaceId}
        defaultOrganizationId={defaultOrganizationId}
        onWorkspaceSelect={onWorkspaceSelect}
        onOrganizationSelect={onOrganizationSelect}
        getDefaultWorkspaceId={getDefaultWorkspaceId}
      />

      {/* Quick Actions */}
      <QuickActions
        canInvite={canInvite}
        activeOrganizationId={activeOrganizationId}
        onInviteClick={onInviteClick}
        onManageOrganizations={onManageOrganizations}
        onManageWorkspaces={onManageWorkspaces}
      />

      <DropdownMenuSeparator className="my-1" />

      {/* Help Links */}
      <HelpLinks />

      <DropdownMenuSeparator className="my-1" />

      {/* Account Actions */}
      <AccountActions onReferFriend={onReferFriend} onLogout={onLogout} />
    </div>
  </>
);
